import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './Tooltip.sass'
import ReactDOM from 'react-dom'
import { useFloatingTooltip } from './useFloatingTooltip'
import { Placement } from '@floating-ui/react'

interface Props {
  content: React.ReactNode
  children: React.ReactElement
  placement?: Placement
  className?: string
}

export default observer(function Tooltip({
  content,
  children,
  className,
  placement, // If placement is not specified, it will automatically find the best placement.
}: Props) {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible, arrowRef } =
    useFloatingTooltip({ trigger: 'hover', placement })

  const childElProps = {
    ref: setTriggerRef,
  }

  return (
    <>
      {React.cloneElement(children, childElProps)}

      {visible &&
        ReactDOM.createPortal(
          <div
            ref={setTooltipRef}
            {...getTooltipProps({
              className: cx(styles.tooltipContainer, className),
            })}
          >
            <div
              ref={arrowRef}
              style={{
                position: 'absolute',
                width: '10px',
                height: '10px',
                background: 'inherit',
                transform: 'rotate(45deg)',
              }}
            />
            {content}
          </div>,
          document.getElementById('app-tooltips-container')!
        )}
    </>
  )
})
